import styled, { css } from 'styled-components'
import { ResizableBox } from 'react-resizable'
import zLayers from 'utils/styling/zLayers'

/**
 * The resize frame and functional handle of a classic (TinyMCE-era) item,
 * identical to staging's; an editor text box's are
 * `ResizeControls.styled.ts`.
 */

type ClassicResizeControlsProps = {
  rotate?: number
  disabled?: boolean
  selected?: boolean
}

export const ClassicResizeControls = styled(
  ResizableBox,
)<ClassicResizeControlsProps>(
  ({ rotate, disabled }) => css`
    width: 100%;
    height: 100%;
    position: relative;
    /* Selection border is now rendered by ItemControlOverlay */
    outline: none;
    ${disabled && `z-index: ${zLayers.behindBackground};`}
    ${rotate ? `transform: rotate(${rotate}deg);` : ''}
    /* Prevent passive event listener warnings for resizable items */
    touch-action: ${disabled ? 'auto' : 'none'};
  `,
)

const ResizeHandlePosition = css`
  bottom: 2px;
  right: 2px;
`

/**
 * The geometry props reach the DOM as attributes, as staging's do; the CSS
 * reads only `position`, `selected` and the lock.
 */
type ClassicResizeHandleProps = {
  x?: number
  y?: number
  z?: number
  height?: number | string
  width?: number | string
  position?: string
  selected?: boolean
  $itemLocked?: boolean
}

export const ClassicResizeHandle = styled.div<ClassicResizeHandleProps>(
  ({ position, selected, $itemLocked }) => css`
    position: absolute;
    ${ResizeHandlePosition}
    width: 24px;
    height: 24px;
    /* Visual handle is rendered by ItemControlOverlay - this is functional only */
    border-bottom: solid 10px transparent;
    border-right: solid 10px transparent;
    border-left: solid 10px transparent;
    border-top: solid 10px transparent;
    cursor: ${$itemLocked ? 'default' : `${position}-resize`};
    /* Use overlay z-index when selected so it's not blocked by other items */
    z-index: ${selected ? zLayers.itemControlOverlay + 1 : 0};
    /* Only show (be interactive) when selected and not locked */
    visibility: ${selected && !$itemLocked ? 'visible' : 'hidden'};
    pointer-events: ${selected && !$itemLocked ? 'auto' : 'none'};
  `,
)
